const config = {
	apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8000",
	recaptcha: {
		sitekey: "6LcNGNMqAAAAAH8joii5iYZdW4g59PntddSVYNN5",
	},
};

export default config;
